import { openMobileWallet as p, toDeepLink as a } from "@roninnetwork/wallet-sdk";
import { WalletExtensionRdns as d } from "../../temp-lib/constants/web3.js";
import f from "../../temp-lib/hooks/web3/useWeb3.js";
import { useState as l, useCallback as u, useEffect as m } from "react";
const b = () => {
  const {
    connectors: r
  } = f(), [n, o] = l(), s = u(() => o(void 0), []), e = r.find((t) => t.id === d.WalletConnect);
  return m(() => {
    if (!e)
      return;
    const t = (i) => {
      i.type === "display_uri" && o(i.data);
    };
    return e == null || e.emitter.on("message", t), () => {
      e == null || e.emitter.off("message", t);
    };
  }, [e]), {
    roninQRCode: n,
    clearQRCode: s,
    openRoninMobileWallet: p,
    getDeepLink: () => n ? a(n) : ""
  };
};
export {
  b as default
};
//# sourceMappingURL=useWalletConnect.js.map
